<template>
    <div id="register-class">
        <MyTitle theTitle="实名注册"/>
        <van-cell-group>
            <van-field
                    v-model="formData.loginName"
                    required
                    clearable
                    label="登录名"
                    placeholder="请输入登录名"
                    @blur="validateLoginName"
            >
                <van-icon
                        v-if="loginNameValidate == 1"
                        slot="right-icon"
                        name="success"
                        color="green"
                ></van-icon>
                <van-icon
                        v-if="loginNameValidate == 2"
                        slot="right-icon"
                        name="cross"
                        color="red"
                ></van-icon>
            </van-field>
            <van-field
                    v-model="formData.sjhm"
                    required
                    clearable
                    label="手机号码"
                    placeholder="请输入有效的手机号码"
                    @blur="validateSjhm"
            >
                <van-icon
                        v-if="sjhmValidate == 1"
                        slot="right-icon"
                        name="success"
                        color="green"
                ></van-icon>
                <van-icon
                        v-if="sjhmValidate == 2"
                        slot="right-icon"
                        name="cross"
                        color="red"
                ></van-icon>
            </van-field>
            <van-field
                    v-model="formData.password"
                    required
                    clearable
                    label="密码"
                    placeholder="8-16位字母、数字、特殊符号两种以上"
            ></van-field>
            <van-field
                    v-model="formData.confirmPassword"
                    required
                    clearable
                    label="确认密码"
                    placeholder="请再次输入密码"
            ></van-field>
            <van-field
                    v-model="formData.zsxm"
                    required
                    clearable
                    label="真实姓名"
                    placeholder="请输入您的真实姓名"
            ></van-field>
            <van-field
                    v-model="formData.sfzh"
                    required
                    clearable
                    label="身份证号"
                    placeholder="请输入您的身份证号"
                    @blur="validateSfzh"
            >
                <van-icon
                        v-if="sfzhValidate == 1"
                        slot="right-icon"
                        name="success"
                        color="green"
                ></van-icon>
                <van-icon
                        v-if="sfzhValidate == 2"
                        slot="right-icon"
                        name="cross"
                        color="red"
                ></van-icon>
            </van-field>
            <van-field
                    v-model="formData.gddh"
                    clearable
                    label="固定电话"
                    placeholder="请输入您的固定电话"
            ></van-field>
            <van-field
                    v-model="formData.email"
                    required
                    clearable
                    label="邮箱"
                    placeholder="请输入您的邮箱"
            ></van-field>
            <van-field
                    required
                    disabled
                    label="经常居住地"
            ></van-field>
            <van-field
                    v-model="formData.jcjzd"
                    type="textarea"
                    placeholder="请输入您的居住地址"
                    rows="1"
                    autosize
            ></van-field>
        </van-cell-group>
        <van-button
                id="login-button"
                type="info"
                size="large"
                round
                @click="registerInfo"
                :disabled="disabled"
        >
            注册并认证
        </van-button>
    </div>
</template>

<script>
    import MyTitle from '@/components/common/myTitle';
    import validate from '@/utils/validator/validator';
    import {
        NotNull
    } from '@/utils/validator/commonRules';

    export default {
        data() {
            return {
                formData: {
                    loginName: '', // 登录名
                    sjhm: '', // 手机号码
                    password: '', // 密码
                    confirmPassword: '', // 确认密码
                    zsxm: '', // 真实姓名
                    sfzh: '', // 身份证号
                    gddh: '', // 固定电话
                    email: '', // 邮箱
                    jcjzd: '' // 经常居住地,
                },
                disabled: false,
                // 数据后端是否存在校验, -1默认, 1成功, 2已存在
                loginNameValidate: -1,
                sjhmValidate: -1,
                sfzhValidate: -1

            }
        },
        components: {
            MyTitle
        },
        methods: {
            registerInfo: function () {
                const validated = this.validateFormData();
                validated.then(() => {
                    this.submitRegistInfo();
                }).then((res) => {
                    console.log("注册返回结果", res.message);
                });
            },
            submitRegistInfo: function () {
                var postData = {
                    cLoginName: this.formData.loginName,
                    cPhoneno: this.formData.sjhm,
                    cPassword: this.formData.password,
                    cZjh: this.formData.sfzh,
                    cGh: this.formData.gddh,
                    cEmail: this.formData.email,
                    cTxdz: this.formData.jcjzd
                };
                if (this.loginNameValidate == 2) {
                    this.$notify("登录名已经存在");
                    return;
                }
                if (this.sjhmValidate == 2) {
                    this.$notify("手机号码已经存在");
                    return;
                }
                if (this.sfzhValidate == 2) {
                    this.$notify("身份证号已经存在");
                    return;
                }
                this.$axios.post('account/api/account', postData).then(res => {
                    console.log("注册账户返回结果为", JSON.stringify(res.data));
                    if (res.code == 201) {
                        this.$notify({type: 'success', message: res.message});
                        this.$router.push("/login");
                    } else {
                        this.$notify(res.message);
                    }
                });
            },
            validateFormData: function () {
                let descriptor = {
                    loginName: new NotNull('string', '请输入登录名'), // 登录名
                    sjhm: new NotNull('string', '请输入手机号码'), // 手机号码
                    password: new NotNull('string', '请输入密码'), // 密码
                    confirmPassword: new NotNull('string', '请确认密码'), // 确认密码
                    zsxm: new NotNull('string', '请输入真实姓名'), // 真实姓名
                    sfzh: new NotNull('string', '请输入身份证号码'), // 身份证号
                    gddh: '', // 固定电话
                    email: new NotNull('string', '请输入邮箱'), // 邮箱
                    jcjzd: new NotNull('string', '请输入经常居住地') // 经常居住地
                };
                const validated = validate(descriptor, this.formData);
                return validated;
            },
            validateLoginName: function () {
                if (this.formData.loginName && this.formData.loginName != "undefined") {
                    this.$axios.post('account/api/account/usernameverificode?username=' + this.formData.loginName).then((res) => {
                        if (res.data) {
                            // 返回结果为true不存在
                            this.loginNameValidate = 1;
                        } else {
                            // 返回结果为false已存在
                            this.loginNameValidate = 2;
                        }
                    });
                }
            },
            validateSjhm: function () {
                if (this.formData.sjhm && this.formData.sjhm != "undefined") {
                    this.$axios.post('account/api/account/phone?phone=' + this.formData.sjhm).then((res) => {
                        if (res.data) {
                            // 返回结果为true不存在
                            this.sjhmValidate = 1;
                        } else {
                            // 返回结果为false已存在
                            this.sjhmValidate = 2;
                        }
                    });
                }
            },
            validateSfzh: function () {
                if (this.formData.sfzh && this.formData.sfzh != "undefined") {
                    this.$axios.post('account/api/account/identity?identity=' + this.formData.sfzh).then((res) => {
                        if (res.data) {
                            // 返回结果为true不存在
                            this.sfzhValidate = 1;
                        } else {
                            // 返回结果为false已存在
                            this.sfzhValidate = 2;
                        }
                    });
                }
            }
        }
    }
</script>

<style scoped>
    #register-class {
        overflow-y: scroll;
        width: 100%;
        height: 100%;
    }
</style>
